import FileIconCell from 'src/components/custom-cells/FileIconCell';
import { GridColumn } from 'src/components/GridWrapper';
import ScannedOnCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/ScannedOnCell';
import SourceCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/SourceCell';
import UploadedByCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/UploadedByCell';
import UploadedOnCell from 'src/sections/invoice_scan_manager/invoice_scan_cell/UploadedOnCell';
import FileNameCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/FileNameCell';
import { SourceFilterMenu } from 'src/sections/invoice_scan_manager/ocr/ocr_cell/SourceFilterMenu';
import StatusOcrCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/StatusOcrCell';
import { FileIcon } from '../scan_manager/scanManagerColumns';

export const ocrScanManagerColumns: GridColumn<any>[] = [
  {
    field: 'selected',
    title: '',
    width: '30px',
  },
  {
    field: 'file',
    title: '',
    component: FileIconCell,
    headerCell: FileIcon,
    width: '50px',
    menu: false,
    sortable: false,
  },
  {
    field: 'originalFile',
    title: 'File Name',
    filter: 'text',
    dataType: 'string',
    component: FileNameCell,
  },
  {
    field: 'createdBy',
    title: 'Uploaded By',
    filter: 'text',
    dataType: 'string',
    editable: false,
    component: UploadedByCell,
  },
  {
    field: 'creationDate',
    title: 'Uploaded On',
    filter: 'date',
    dataType: 'date',
    editable: false,
    component: UploadedOnCell,
  },
  {
    field: 'source',
    title: 'Source',
    filter: 'text',
    dataType: 'string',
    editable: false,
    component: SourceCell,
    columnMenu: SourceFilterMenu,
  },
  {
    field: 'scannedOn',
    title: 'Scan Completed On',
    filter: 'date',
    dataType: 'date',
    editable: false,
    format: 'MM/dd/yyyy hh:mm a',
    component: ScannedOnCell,
  },
  {
    field: 'ocrStatus',
    title: 'OCR Status',
    filter: 'text',
    dataType: 'string',
    editable: false,
    menu: false,
    component: StatusOcrCell,
  },
];

export default ocrScanManagerColumns;
